module.exports = __webpack_public_path__ + "static/media/download_csv.61e56c27.svg";